export default __webpack_public_path__ + "static/char-s-39-ja-b54cf0bed25c81e693f83bd24a43a383.webp";